import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { LeftPanel } from "./Login";
import "../styles/auth.css";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-layout" data-testid="forgot-password-page">
      <LeftPanel />
      <div className="auth-right">
        <div className="auth-form-wrap">
          {sent ? (
            <div className="auth-success-screen">
              <div className="auth-success-icon">✉️</div>
              <div className="auth-success-title">Vérifiez votre boîte mail</div>
              <p className="auth-success-sub">
                Si un compte existe pour <strong>{email}</strong>, un lien de
                réinitialisation vient de lui être envoyé. Il est valable 1 heure.
              </p>
              <p className="auth-bottom-link">
                <Link to="/login">← Retour à la connexion</Link>
              </p>
            </div>
          ) : (
            <>
              <h2 className="auth-title">Mot de passe oublié ?</h2>
              <p className="auth-subtitle">
                Indiquez l'adresse email de votre compte : nous vous enverrons un
                lien pour choisir un nouveau mot de passe.
              </p>

              {error && (
                <div className="auth-alert auth-alert-error">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                    <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
                  </svg>
                  {error}
                </div>
              )}

              <form onSubmit={submit}>
                <div className="auth-field-group">
                  <label className="auth-field-label" htmlFor="email">Adresse email</label>
                  <div className="auth-field-wrap">
                    <input type="email" id="email" placeholder="votre@email.com" autoComplete="email" required
                      value={email} onChange={e => setEmail(e.target.value)} data-testid="forgot-email" />
                    <div className="auth-field-icon">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
                        <rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-10 7L2 7"/>
                      </svg>
                    </div>
                  </div>
                </div>

                <button type="submit" className="auth-btn-submit" disabled={loading} data-testid="forgot-submit">
                  {loading ? (
                    <><span className="auth-spinner"/><span>Envoi…</span></>
                  ) : (
                    <span>Envoyer le lien</span>
                  )}
                </button>
              </form>

              <p className="auth-bottom-link">
                <Link to="/login">← Retour à la connexion</Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
